module.exports = __webpack_public_path__ + "img/v1.88ff4b42.png";